import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainNavbar from './Navbar';
import Header from './Component/Helmet';
import './custom-styles.scss';

// Gdy użytkownik ma otwartą kartę w chwili deployu, stary index.html wskazuje na
// chunki, których już nie ma → import() rzuca. Wtedy raz przeładowujemy stronę
// (świeży index.html + nowe chunki). Bez tego trzeba było robić twardy reload.
const RELOAD_KEY = 'rp-chunk-reload';
const lazyWithReload = (factory) =>
  lazy(() =>
    factory().catch((err) => {
      if (!sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, Date.now().toString());
        window.location.reload();
        return new Promise(() => {}); // wisi do przeładowania
      }
      throw err;
    })
  );

// Code-splitting per trasa: użytkownik wchodzący prosto na /results/... nie
// powinien ściągać kodu strony głównej, kar czy listy startowej.
const Home = lazyWithReload(() => import('./Home'));
const About = lazyWithReload(() => import('./About'));
const PrivacyPolicy = lazyWithReload(() => import('./PrivacyPolicy'));
const PrivacyPolicyApp = lazyWithReload(() => import('./PrivacyPolicyApp'));
const Results = lazyWithReload(() => import('./Results'));
const ApiPage = lazyWithReload(() => import('./ApiPage'));
const PagePenalties = lazyWithReload(() => import('./Penalties'));
const StartListPage = lazyWithReload(() => import('./features/startList/StartListPage'));
const SplitsPage = lazyWithReload(() => import('./features/splits/SplitsPage'));
const CompetitorPage = lazyWithReload(() => import('./features/splits/CompetitorPage'));
const RallyStatsPage = lazyWithReload(() => import('./features/splits/RallyStatsPage'));

const RouteFallback = () => <div className="loading-spinner" />;

const App = () => {
  // Aplikacja wstała → reset budżetu „jednego przeładowania" na kolejny deploy.
  useEffect(() => {
    sessionStorage.removeItem(RELOAD_KEY);
  }, []);

  return (
    <Router>
      <div>
      <Header />
        <Routes>
          <Route path="/about" element={<MainNavbar showAllMenu={false} />} />
          {/* /penalties/* renderuje teraz własny <Navbar EventID=.../> w Penalties.js (tak jak
              Results/Splits/Competitor/RallyStats/StartList) — wcześniej ten wpis montował
              MainNavbar bez EventID, więc znikały pozycje menu zależne od EventID. */}
          {/* <Route path="/results/*" element={<MainNavbar showAllMenu={true} />} />*/}
       {/*   <Route path="/" element={<MainNavbar showAllMenu={true} />} />*/}
          <Route path="/api" element={<MainNavbar showAllMenu={true} />} />
        </Routes>

        {/* Render different components based on the route */}
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy/app" element={<PrivacyPolicyApp />} />
            <Route path="/penalties/:eventID" element={<PagePenalties />} /> {/* Pass the eventID param */}
            <Route path="/results/:EventID" element={<Results />} />
            <Route path="/splits/:EventID" element={<SplitsPage />} />
            <Route path="/competitor/:EventID" element={<CompetitorPage />} />
            <Route path="/rally-stats/:EventID" element={<RallyStatsPage />} />
            <Route path="/start-list/:EventID" element={<StartListPage />} />
            <Route path="/" element={<Home />} />
            <Route path="/api" element={<ApiPage />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
